import { type FpPaymentInfo } from '@hooks-api/types/dataModel/fpOrder'
import { PaymentMethodMap, PaymentMethodType } from '@hooks-api/types/dataModel/payment'
import { Box } from '@pets-ui/Box/Box'
import { HStack } from '@pets-ui/HStack/HStack'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { VStack } from '@pets-ui/VStack/VStack'
import * as stylex from '@stylexjs/stylex'
import { AtmPaymentInfo, Notice } from './AtmPaymentInfo'
import { CvsPaymentInfo } from './CvsPaymentInfo'

const styles = stylex.create({
  info: {
    display: 'grid',
    gridTemplateColumns: '1fr 3fr',
  },
})

interface PaymentInfoProps {
  shouldShowPdf?: boolean
  paymentMethod?: PaymentMethodType
  needPdf?: boolean
  postingDateInNextMonth?: boolean
  paymentInfo?: FpPaymentInfo | null
  rootStyle?: stylex.StyleXStyles
}

export const PaymentInfo = ({ shouldShowPdf, paymentMethod, needPdf, postingDateInNextMonth, paymentInfo, rootStyle }: PaymentInfoProps) => {
  const isAtmPayment = paymentMethod === PaymentMethodType.ATM
  const isCvsPayment = paymentMethod === PaymentMethodType.CVS
  return (
    <VStack rootStyle={rootStyle}>
      <Text variant="subtitle">付款資訊</Text>
      <Box rootStyle={styles.info}>
        <Text variant="body" color={colors.grey600}>付款方式</Text>
        <VStack gap={1}>
          {
            paymentMethod
            && <Text variant="body">{PaymentMethodMap[paymentMethod]}</Text>
          }
          <HStack>
            {
              needPdf && shouldShowPdf
              && <Text variant="body" color={colors.grey500}>附上訂單明細 (PDF INV)</Text>
            }
            {
              needPdf && postingDateInNextMonth
              && <Text variant="body" color={colors.grey500}>{', '}</Text>
            }
            {
              postingDateInNextMonth
              && <Text variant="body" color={colors.grey500}>跨月帳款</Text>
            }
          </HStack>
        </VStack>
      </Box>

      {isAtmPayment
      && (
        <>
          <AtmPaymentInfo paymentInfo={paymentInfo} />
          <Notice />
        </>
      )}
      {isCvsPayment
      && (
        <>
          <CvsPaymentInfo paymentInfo={paymentInfo} />
          <Notice />
        </>
      )}
    </VStack>
  )
}
